import React from 'react';
import Faq from './landing-comp/Faq';
import Hero from './landing-comp/Hero';
import Feature from './landing-comp/Feature';
import Cta from './landing-comp/Cta';
import Education from './landing-comp/Education';
import Header from './landing-comp/Header'
import Mission from './landing-comp/Mission'
import Testimonials from './landing-comp/Testimonials';
import Footer from './landing-comp/Footer';
import { discoverFeatures } from './data/discoverFeatures'
import { quiktradeFeatures } from './data/quiktradeFeatures'



const LandingDev = () => {

  return (
    <div className="poppins">
     <Header />
     <Hero />
     <Feature
        features={discoverFeatures}
        title="Discover"
        subtitle="Advanced Insights for smarter trading"
        theme="blue"
      />
      <Feature
        features={quiktradeFeatures}
        title="Quiktrade"
        subtitle="Execute Trades with Precision"
        theme="white"
      />
      <Mission />
      <Testimonials />
      <Education />
      <Faq />
      <Cta />
      <Footer />  
    </div>
  );
};

export default LandingDev;
